import { css } from '@emotion/core'
import { colors } from 'styles/variables'

export const formWrapper = css`
  padding: 24px;
`

export const row = css`
  margin-bottom: 8px;
  background: ${colors.grays.gray7};
  border-radius: 4px;

  button:disabled {
    background-color: ${colors.grays.gray7};
    color: rgba(255, 255, 255, 0.6);
    border: 1px solid rgba(255, 255, 255, 0.6);
    opacity: 1;
  }
`

export const buttonGroup = css`
  display: flex;
  gap: 6px;
  align-items: center;
  flex-wrap: wrap;
  justify-content: flex-end;
  width: 100%;
  padding: 4px;

  button {
    min-width: 90px;
    max-width: 110px;
    white-space: nowrap;
    flex-shrink: 0;
    background-color: ${colors.greens.green7};
    border: none;
    border-radius: 16px;
    padding: 6px 12px;
    font-size: 12px;
    transition: all 0.3s ease;

    @media (max-width: 480px) {
      width: 100%;
      max-width: none;
    }

    &:hover:not(:disabled) {
      background-color: ${colors.greens.green8};
    }

    &[data-loading="true"] {
      cursor: not-allowed;
      position: relative;
      color: transparent;

      &::after {
        content: '';
        position: absolute;
        left: 50%;
        top: 50%;
        width: 16px;
        height: 16px;
        margin: -8px 0 0 -8px;
        border: 2px solid rgba(255, 255, 255, 0.2);
        border-top-color: white;
        border-radius: 50%;
        animation: button-loading-spinner 1s linear infinite;
      }
    }
  }

  button:disabled {
    background-color: ${colors.grays.gray7};
    color: rgba(255, 255, 255, 0.6);
    border: 1px solid rgba(255, 255, 255, 0.6);
    opacity: 1;
  }

  @keyframes button-loading-spinner {
    from {
      transform: rotate(0turn);
    }
    to {
      transform: rotate(1turn);
    }
  }
`

export const noDataWrapper = css`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  padding: 24px;
`

export const tooltip = css`
  background-color: ${colors.grays.gray7} !important;
  padding: 6px 10px;
  border-radius: 4px;
  min-width: 240px;
  max-width: 280px;
  display: flex;
  justify-content: center;
  align-items: center;
  position: fixed;
  transform: translate(-50%, -100%);
  white-space: normal;
  text-align: center;
  margin-bottom: 6px;
  z-index: 9999;
  line-height: 1.3;
`
